module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "right-panel-add",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Add Instance")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-form', {
    ref: "addForm",
    staticClass: "add-form",
    attrs: {
      "model": _vm.addForm,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.resourceName,
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.resourceName
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.addForm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.ipAddress,
      "prop": "ipAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "IP"
    },
    model: {
      value: (_vm.addForm.ipAddress),
      callback: function($$v) {
        _vm.addForm.ipAddress = $$v
      },
      expression: "addForm.ipAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.os,
      "prop": "os"
    }
  }, [_c('el-select', {
    on: {
      "change": _vm.selectDefault
    },
    model: {
      value: (_vm.addForm.os),
      callback: function($$v) {
        _vm.addForm.os = $$v
      },
      expression: "addForm.os"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Windows",
      "value": "win32"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Linux",
      "value": "linux"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.username,
      "prop": "username"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addForm.username),
      callback: function($$v) {
        _vm.addForm.username = $$v
      },
      expression: "addForm.username"
    }
  }), _vm._v(" "), _c('translate', [_vm._v("Multiple users with semicolons ‘;’")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.port,
      "prop": "port"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addForm.port),
      callback: function($$v) {
        _vm.addForm.port = $$v
      },
      expression: "addForm.port"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.flavor,
      "prop": "flavor"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": _vm.attrText.defaultFlavorText
    },
    model: {
      value: (_vm.addForm.flavor),
      callback: function($$v) {
        _vm.addForm.flavor = $$v
      },
      expression: "addForm.flavor"
    }
  })], 1), _vm._v(" "), (_vm.addForm.os === 'win32') ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.clipboard
    }
  }, [_c('el-switch', {
    staticStyle: {
      "margin-right": "16px"
    },
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.addForm.clipboard),
      callback: function($$v) {
        _vm.addForm.clipboard = $$v
      },
      expression: "addForm.clipboard"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.btnDisabled,
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.onSubmitAddForm()
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onCloseForm()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71d5ebc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/model/cluster-add-instance.vue
// module id = 587
// module chunks = 4 5 6